const geneidlist = [
  {
    species: "AmericanLotus2022",
    gene_id: ["NL1g_00003.1","NL1g_00003","NL1g_00003"],
  },
  {
    species: "AmericanLotus2024",
    gene_id: ["chr1.g00006.m1","chr1.g00006","chr1.g00006"],
  },
  { species: "AsianLotus", gene_id: ["Chr01.g00060.m1","Chr01.g00060","Chr01.g00060"], },
  {
    species: "ZiLotus",
    gene_id: ["OF25078.mRNA1","OF25078","OF25078"],
  },
  
];
export default geneidlist